import { Banner, spacer24 } from '@spotify-internal/encore-web';
import styled from 'styled-components';

export const NotificationStyled = styled(Banner)`
  margin-bottom: ${spacer24};
`;
